// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__m1VIV","ltr":"styles_ltr__Hf5lF","rtl":"styles_rtl__CCIfz","overlay":"styles_overlay__V9JcL"};